var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 72,
    viewBox: "0 0 168 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_4253)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.0002 36.0006C49.6693 36.0006 60.7502 29.9565 60.7502 22.5006C60.7502 15.0448 49.6693 9.00061 36.0002 9.00061C22.3312 9.00061 11.2502 15.0448 11.2502 22.5006C11.2502 29.9565 22.3312 36.0006 36.0002 36.0006Z",
    fill: "#F27DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 36.0005C49.669 36.0005 60.75 29.9563 60.75 22.5005C60.75 15.0446 49.669 9.00049 36 9.00049C22.331 9.00049 11.25 15.0446 11.25 22.5005C11.25 29.9563 22.331 36.0005 36 36.0005Z",
    stroke: "#F27DB4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5007V36.0007C11.25 43.4539 22.3313 49.5007 36 49.5007C49.6687 49.5007 60.75 43.4539 60.75 36.0007V22.5007",
    stroke: "#F27DB4",
    strokeOpacity: 0.8,
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 36.0005V49.5005C11.25 56.9536 22.3313 63.0005 36 63.0005C49.6687 63.0005 60.75 56.9536 60.75 49.5005V36.0005",
    stroke: "url(#paint0_linear_633_4253)",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.309 20.9812C105.105 21.3312 104.998 21.7293 105 22.1343V49.8656C105.002 50.2661 105.109 50.6591 105.312 51.0047C105.514 51.3504 105.804 51.6365 106.153 51.8343L130.903 65.7562C131.236 65.9469 131.615 66.044 132 66.0375L132.253 36L105.309 20.9812Z",
    fill: "#4C94FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 49.8656V22.1344C158.997 21.7338 158.89 21.3409 158.687 20.9952C158.485 20.6496 158.195 20.3634 157.846 20.1656L133.096 6.24374C132.763 6.05119 132.385 5.94983 132 5.94983C131.614 5.94983 131.236 6.05119 130.903 6.24374L106.153 20.1656C105.804 20.3634 105.514 20.6496 105.312 20.9952C105.109 21.3409 105.002 21.7338 105 22.1344V49.8656C105.002 50.2662 105.109 50.6591 105.312 51.0047C105.514 51.3504 105.804 51.6366 106.153 51.8344L118.528 58.7953L130.903 65.7562C131.236 65.9488 131.614 66.0501 132 66.0501C132.385 66.0501 132.763 65.9488 133.096 65.7562L157.846 51.8344C158.195 51.6366 158.485 51.3504 158.687 51.0047C158.89 50.6591 158.997 50.2662 159 49.8656Z",
    stroke: "url(#paint1_linear_633_4253)",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.692 20.9812L132.254 36L105.311 20.9812",
    stroke: "#4C94FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.255 36.0002L132.001 66.0377",
    stroke: "url(#paint2_linear_633_4253)",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_633_4253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 36L72 36",
    stroke: "#718096",
    strokeWidth: 3,
    strokeDasharray: "8 8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_633_4253",
    x: 66,
    y: 28.5,
    width: 35,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_633_4253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_633_4253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_633_4253",
    x1: 36,
    y1: 36.0005,
    x2: 36,
    y2: 85.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27DB4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_633_4253",
    x1: 132,
    y1: 26.0001,
    x2: 132,
    y2: 81.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_633_4253",
    x1: 132.128,
    y1: 36.0002,
    x2: 132.128,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_4253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/business-icon.f20c36bbc9aafbbf999399286b83b8c2.svg";
export { ForwardRef as ReactComponent };